import React, { FC } from 'react';

import { TableCell, TableRow } from '@material-ui/core';

import { ScoreType } from '../../../../../../../../../../../store/admin/eventFormats/store';

import { useAssignResultsState } from '../../../../../../../../Common/AssignResults/Context/AssignResults.context';
import { ISkinsTableRow } from '../SkinsTableRow';

const SkinsTableSingleRow: FC<ISkinsTableRow> = props => {
  const { hole, index } = props;
  const { selectedCombination, skinsResults } = useAssignResultsState();

  return selectedCombination ? (
    <TableRow
      id={`clickableRowResult-${index}`}
      key={`tableRowResult-${index}`}
      className="results-table-table-body-row"
    >
      <TableCell className="index">{Number(hole) + 1}</TableCell>

      <TableCell className="playerName">
        {`${skinsResults[Number(hole)][0].userFirstName[0]}. ${
          skinsResults[Number(hole)][0].userLastName
        }`}
      </TableCell>

      <TableCell className="result">
        {
          skinsResults[Number(hole)][0][
            ScoreType[selectedCombination.scoreType].toLowerCase() as 'gross' | 'net'
          ]
        }
      </TableCell>

      <TableCell className="ribbon-metaContainer">
        <div className="ribbon-container">
          <span className="ribbon">SKIN</span>
        </div>
      </TableCell>
    </TableRow>
  ) : (
    <></>
  );
};

export default SkinsTableSingleRow;
